import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6664b669 = () => interopDefault(import('../pages/countries.vue' /* webpackChunkName: "pages/countries" */))
const _79564fc8 = () => interopDefault(import('../pages/help.vue' /* webpackChunkName: "pages/help" */))
const _3474bdc4 = () => interopDefault(import('../pages/no-subscription.vue' /* webpackChunkName: "pages/no-subscription" */))
const _723221b7 = () => interopDefault(import('../pages/redirect.vue' /* webpackChunkName: "pages/redirect" */))
const _53244b88 = () => interopDefault(import('../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _2c701c07 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _1bf3293f = () => interopDefault(import('../pages/_countryCode.vue' /* webpackChunkName: "pages/_countryCode" */))
const _11a58482 = () => interopDefault(import('../pages/_countryCode/index.vue' /* webpackChunkName: "pages/_countryCode/index" */))
const _2f9f1c4c = () => interopDefault(import('../pages/_countryCode/_disciplineCode.vue' /* webpackChunkName: "pages/_countryCode/_disciplineCode" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'hash',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/countries",
    component: _6664b669,
    name: "countries"
  }, {
    path: "/help",
    component: _79564fc8,
    name: "help"
  }, {
    path: "/no-subscription",
    component: _3474bdc4,
    name: "no-subscription"
  }, {
    path: "/redirect",
    component: _723221b7,
    name: "redirect"
  }, {
    path: "/terms",
    component: _53244b88,
    name: "terms"
  }, {
    path: "/",
    component: _2c701c07,
    name: "index"
  }, {
    path: "/:countryCode",
    component: _1bf3293f,
    children: [{
      path: "",
      component: _11a58482,
      name: "countryCode"
    }, {
      path: ":disciplineCode",
      component: _2f9f1c4c,
      name: "countryCode-disciplineCode"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
